import React, { useContext } from 'react'
import { makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import TopBar from './TopBar'
import MobileHead from './MobileHead'
import Footer from './Footer'
import { Context as PortfolioContext } from '../contexts/portfolio'

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100vh',
    // overflow: 'hidden',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    // overflow: 'hidden',
    paddingLeft: 0,
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    // overflow: 'hidden',
    scrollBehavior: 'smooth',
  },
  content: {
    flex: '1 1 auto',
    flexDirection: 'column',
    display: 'flex',
    scrollBehavior: 'smooth',
  },
  footerWrapper: {
    marginTop: 'auto',
  },
}))

interface DashboardLayoutProps {
  children: any
  callBackFunc?: any
}

const DashboardLayout = ({ children, callBackFunc }: DashboardLayoutProps) => {
  const classes = useStyles()
  const { loadMore, currentScrollPosition, setBottom } = useContext(
    PortfolioContext,
  )

  const handleScrollTable = (e: any) => {
    const pathName = window.location.pathname
    if (pathName === '/' || pathName.indexOf('portfolio') !== -1) {
      currentScrollPosition(e.target.scrollTop)
      if (
        e.target.scrollHeight - e.target.scrollTop ===
        e.target.clientHeight
      ) {
        setBottom(true)
      } else {
        setBottom(false)
      }
      const bottom =
        e.target.scrollHeight - e.target.scrollTop <=
        e.target.clientHeight + 200
      if (bottom) {
        loadMore(Math.random())
      }
    }
  }

  return (
    <div className={classes.root}>
      {!isMobile && <TopBar />}
      {isMobile && <MobileHead />}
      <div className={classes.wrapper}>
        <div
          className={classes.contentContainer}
          style={
            window.location.pathname === '/' ||
            window.location.pathname.indexOf('portfolio') !== -1
              ? {
                  marginTop: `${isMobile ? '75px' : 'unset'}`,
                }
              : {
                  marginTop: `${isMobile ? '60px' : 'unset'}`,
                }
          }
        >
          <div className={classes.content} onScroll={handleScrollTable}>
            {children}
            <div
              className={classes.footerWrapper}
              style={
                window.location.pathname === '/' ||
                window.location.pathname.indexOf('portfolio') !== -1
                  ? {}
                  : {
                      marginBottom: 100,
                    }
              }
            >
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardLayout
